import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import lity from "lity";

const mainElement = document.querySelector("main.p-rooms");
if (mainElement) {
  $(function () {
    $(".slick").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      asNavFor: ".slick_thumb",
      arrows: false,
      autoplay: true,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: "21.5%",
      responsive: [
        {
          breakpoint: 769,
          settings: {
            centerPadding: "0%",
          },
        },
      ],
    });
    $(".slick_thumb").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".slick",
      centerMode: true,
      focusOnSelect: true,
      arrows: false,
    });
  });
  //画像拡大表示
  document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll(".open-lightbox");
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        lity(link.getAttribute("href"));
      });
    });
  });

  document.addEventListener("DOMContentLoaded", () => {
    $(function () {
      // メインスライダーの初期化
      $(".slick-main-single").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        // adaptiveHeight: true,
        // centerMode: true,
        asNavFor: ".slick_thumb-img",
        responsive: [
          {
            breakpoint: 769,
            settings: {
              centerPadding: "0%",
            },
          },
        ],
      });

      // サムネイルスライダーの初期化
      $(".slick_thumb-img").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: ".slick-main-single",
        // centerMode: true,
        focusOnSelect: true,
        arrows: false,
      });
    });
  });
}

//英語用
document.addEventListener("DOMContentLoaded", () => {
  // 各スライダーを対象に初期化
  document
    .querySelectorAll(".p-roomlist-room__image--slide")
    .forEach((slideContainer) => {
      const mainSlider = slideContainer.querySelector(".slick-main-single");
      const thumbSlider = slideContainer.querySelector(".slick_thumb-img");

      // メインスライダーの初期化
      if ($(mainSlider).length) {
        $(mainSlider).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 1500,
          asNavFor: thumbSlider, // サムネイルスライダーと連動
          waitForAnimate: false, // 切り替え中でも操作可能
          responsive: [
            {
              breakpoint: 769,
              settings: {
                centerPadding: "0%",
              },
            },
          ],
        });

        // サムネイルスライダーの初期化
        $(thumbSlider).slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: mainSlider, // メインスライダーと連動
          focusOnSelect: true,
          arrows: false,
        });
      }
    });
});
